import React from 'react';
import './index.scss';

const InfoSection = ({
  image,
  content,
  reverse = false,
}) => {
  return (
    <section className={`info-section ${reverse ? 'reverse' : ''}`}>
      <div className="info-section__image">
        {image}
      </div>
      <div className="info-section__content">
        {content}
      </div>
    </section>
  );
};

export default InfoSection;
